import { CustomLabelField } from './CustomLabelField';

export function ChannelCustomLabelsSection({
  notFoundOverride,
  notFoundValue,
  onNotFoundToggle,
  onNotFoundChange,
  notHelpfulOverride,
  notHelpfulValue,
  onNotHelpfulToggle,
  onNotHelpfulChange,
  isReadOnly = false,
}: {
  notFoundOverride: boolean;
  notFoundValue: string;
  onNotFoundToggle: (enabled: boolean) => void;
  onNotFoundChange: (value: string) => void;
  notHelpfulOverride: boolean;
  notHelpfulValue: string;
  onNotHelpfulToggle: (enabled: boolean) => void;
  onNotHelpfulChange: (value: string) => void;
  isReadOnly?: boolean;
}) {
  return (
    <div>
      <h3 className="mb-3 text-sm font-semibold text-gray-700">
        Custom Labels
      </h3>
      <p className="mb-4 text-xs text-gray-500">
        Override the default labels for this channel
      </p>

      {/* Not Found Message */}
      <CustomLabelField
        title="Initial Support Message"
        description="Displayed when an answer is not found initially"
        isOverridden={notFoundOverride}
        value={notFoundValue}
        onToggle={onNotFoundToggle}
        onValueChange={onNotFoundChange}
        placeholder="Enter custom support message for this channel..."
        isReadOnly={isReadOnly}
      />

      {/* Not Helpful Message */}
      <CustomLabelField
        title="Not Helpful Support Message"
        description="Displayed when an answer is marked as not helpful"
        isOverridden={notHelpfulOverride}
        value={notHelpfulValue}
        onToggle={onNotHelpfulToggle}
        onValueChange={onNotHelpfulChange}
        placeholder="Enter custom not helpful message for this channel..."
        isReadOnly={isReadOnly}
      />
    </div>
  );
}
